/*Drawer heading tabs start*/
document.addEventListener('click', function(e) {
  const clickedTab = e.target.closest('.drawer-tab');
  if (!clickedTab) return;
  const wrapper = clickedTab.closest('.drawer__inner');
  if (!wrapper) return;
  const tabs = wrapper.querySelectorAll('.drawer-tab');
  const cartContent = wrapper.querySelector('.dawn-drawer-content');
  const recentContent = wrapper.querySelector('.dawn-recently-viewed-wrapper');
  tabs.forEach(tab => {
    tab.classList.remove('active');
  });
  clickedTab.classList.add('active');
  if (clickedTab.dataset.tab === 'cart') {
    cartContent.classList.add('active-tab');
    recentContent.classList.remove('active-tab');
  } else {
    recentContent.classList.add('active-tab');
    cartContent.classList.remove('active-tab');
  }
});
/*Drawer heading tabs ends*/

window.loadCartDrawerRecommendations = async function () {

  const container = document.querySelector(
    '[data-cart-recommendations]'
  );

  if (!container) return;

  try {

    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    // Empty cart
    if (!cart.items || !cart.items.length) {

      container.innerHTML = '';

      return;
    }

    const firstProductId =
      cart.items[0].product_id;

    // Prevent duplicate reload
    const loadedProductId =
      container.dataset.loadedProductId;

    if (
      loadedProductId ===
      String(firstProductId)
    ) {
      return;
    }

    const recommendationsUrl =
      `/recommendations/products?section_id=cart-drawer-recommendations&product_id=${firstProductId}&limit=4&intent=related`;

    const recResponse =
      await fetch(recommendationsUrl);

    const html =
      await recResponse.text();

    /* ------------------------------
       PARSE HTML
    ------------------------------ */

    const wrapper =
      document.createElement('div');

    wrapper.innerHTML = html;

    const content = wrapper.querySelector(
      '.cart-drawer-recommendations__content'
    );

    /* ------------------------------
       RENDER
    ------------------------------ */

    if (content) {

      container.innerHTML =
        content.outerHTML;

      container.dataset.loadedProductId =
        String(firstProductId);

      // INIT SWIPER
      initCartRecSwiper();

    } else {

      container.innerHTML = '';

      container.dataset.loadedProductId =
        String(firstProductId);
    }

  } catch (error) {

    console.error(
      'Failed to load cart drawer recommendations:',
      error
    );
  }
};

function initCartRecSwiper() {

  const swiperEl =
    document.querySelector(
      '.cart-rec-swiper'
    );

  if (!swiperEl) return;

  // Prevent duplicate initialization
  if (
    swiperEl.classList.contains(
      'swiper-initialized'
    )
  ) {
    return;
  }

  // Parent recommendation wrapper
  const parentWrapper =
    swiperEl.closest(
      '.cart-drawer-recommendations__content'
    );

  new Swiper(swiperEl, {

    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,

    navigation: {

      nextEl:
        parentWrapper.querySelector(
          '.swiper-button-next'
        ),

      prevEl:
        parentWrapper.querySelector(
          '.swiper-button-prev'
        ),
    },

    pagination: {

      el:
        parentWrapper.querySelector(
          '.swiper-pagination'
        ),

      clickable: true,
    },

    breakpoints: {

      768: {
        slidesPerView: 1,
      },

      1024: {
        slidesPerView: 1,
      },
    },
  });
}

function initCartRecommendationObserver() {

  const observer =
    new MutationObserver(() => {

      const container =
        document.querySelector(
          '[data-cart-recommendations]'
        );

      if (container) {

        window.loadCartDrawerRecommendations();
      }
    });

  observer.observe(document.body, {

    childList: true,

    subtree: true,
  });
}


/* =========================================
   INIT
========================================= */

document.addEventListener(
  'DOMContentLoaded',
  function () {

    // Load recommendations
    window.loadCartDrawerRecommendations();

    // Observe drawer changes
    initCartRecommendationObserver();
  }
);